import Ajax from 'js/utils/ajax/ajax';

export const downloadInvoiceBatch = (invoiceBatchId: number) =>
  Ajax.getFileBlob(`invoices/v1/invoicebatches/${invoiceBatchId}/excelfile`);
